 // Filter products by size
  // --------------------------------------

  $('.size-filter-option').on('click', function(event){
    event.preventDefault();

    // Handle the filter nav buttons -------------->

    // remove not filtering indicator class if present, and add filtering indicator class
    $(this).removeClass('js-not-filtering').addClass('js-current-filter');

    // add not filtering class to rest of buttons
    $(this).siblings('.size-filter-option').removeClass('js-current-filter').addClass('js-not-filtering');

    // Handle the products to filter -------------->

    // grab the variant title and make it the filter value
    var filteringBy = $(this).text();
    filteringBy = "size-" + filteringBy;

    if(filteringBy == 'size-All') {
      $('.js-size-filter').removeClass('hidden');
    } else {
      $('.js-size-filter').each(function() {
        if(!$(this).hasClass(filteringBy)) {
          $(this).addClass('hidden');
        } else {
          $(this).removeClass('hidden');
          $(this).addClass('active-filter');
        }
      });
    }

  });



(function($) {
	
  $(".mobile-menu a.parent-link").removeAttr('href');    

	
	$('#mobile-button').click(function() { 
		$("#mobile-container").show(); 
		
	});

	$("li.submenu ul.submenu").hide();
$("li.submenu").click(function(){
	$("li.submenu ul.submenu").hide();
	$(this).children('ul.submenu').slideToggle();
});
	
$("li.sub-submenu ul.sub-submenu").hide();
$("li.sub-submenu").click(function(){
	$("li.sub-submenu ul.sub-submenu").hide();
	$(this).children('ul.sub-submenu').slideToggle();
});
	
	
	$('.thumb a').click(function() {
	var newImage = $(this).attr('href');
	$( 'div#main-image img' ).attr({ src: newImage }); 
	return false;
	});
    
  var allPanels = $('.accordion > dd').hide();
    
  $('.accordion > dt > a').click(function() {
    allPanels.slideUp();
    $(this).parent().next().slideDown();
    return false;
  });

})(jQuery);

function openTab(evt, tabName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the link that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

jQuery(document).ready(function(){

	$('#mobile-button').click(function(){
		$("#mobile-container").css({"left":"0px"});
	});
	
	$('#mobile-container .close').click(function(){
		$("#mobile-container").css({"left":"-110%"});	
	});
	
	$('.search-button').click(function(){
		$("#header-wrapper #search-form").show();
	});
	
	
	

  // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });

  $(function() {
    $(".rslides").responsiveSlides();
    $(".rslides2").responsiveSlides();
  });
  
  $('#example').breakingNews({
  effect: 'slide-up'
});

  
});
